import {Button, Col, Form, Row, Space, Spin, message} from "antd";
import {InputFields} from "components/common";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {fields as fieldsInit} from "./ModalAction.config";
import {glassStoreService} from "api";
import Notification from "components/common/notification/notification";
import {Rule} from "antd/es/form";

const ModalAction = forwardRef((props: any, ref) => {
  const {data, closeModal, type, getList, setCurrentPage} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [listExistCode, setListExistCode] = useState<any[]>([]);
  const [rules, setRules] = useState<Rule[]>(
    fieldsInit.find(e => e.name == "code").rules
  );
  const [fields, setFields] = useState(fieldsInit);
  const [listStore, setListStore] = useState<any[]>();
  useImperativeHandle(ref, () => ({
    resetFields: () => {
      form.resetFields();
    },
  }));
  useEffect(() => {
    getListStore();
  }, []);
  useEffect(() => {
    // console.log(listStore);
    const setOptionStore = listStore => {
      fieldsInit.find(e => e?.name == "storeDtos").options = listStore?.map(
        e => ({
          value: e?.id,
          label: e?.name,
        })
      );
      setFields(fieldsInit);
    };
    setOptionStore(listStore);
  }, [listStore]);
  const getListStore = async () => {
    try {
      const res = await glassStoreService.getListStore(1, 20, "false");
      setListStore(res?.data);
    } catch (error) {}
  };
  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
      form.setFieldValue("storeDtos", []);
    } else {
      form.setFieldsValue(formatData(data));
    }
  }, [data, type]);
  const getListStoreDto = listId => {
    const listStoreDto = listStore.filter(e => listId?.includes(e?.id));
    return listStoreDto;
  };
  const formatData = data => {
    return {
      ...data,
      storeDtos: data?.storeDtos.map(e => {
        return e?.id;
      }),
    };
  };
  const addStore = async () => {
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),
        storeDtos: getListStoreDto(form.getFieldValue("storeDtos")),
        // kieuKho: "TT",
        // loaiKhoId: 0,
        // nhomKho: "TH",
      };
      await glassStoreService.createKVT(params);
      setCurrentPage(1);
      setLoading(false);
      closeModal();
      Notification("success", `Đã thêm mới vật tư kính`);
      await getList();
    } catch (error) {
      setLoading(false);

      Notification(
        "error",
        error?.response?.data ?? `Đã có lỗi khi thêm mới vật tư kính`
      );
    }
  };
  const updateStore = async () => {
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),
        storeDtos: getListStoreDto(form.getFieldValue("storeDtos")),
        // kieuKho: "TT",
        // loaiKhoId: 0,
        // nhomKho: "TH",
      };
      const res = await glassStoreService.editKVT(params);
      setLoading(false);
      closeModal();
      Notification("success", `Đã sửa thông tin vật tư kính`);
      await getList();
    } catch (error) {
      setLoading(false);
      if (error?.response?.data.includes("tồn tại")) {
        Notification("error", error?.response?.data);
      } else {
        Notification("error", `Đã có lỗi khi thêm mới vật tư kính`);
      }
    }
  };
  const onFinish = values => {
    if (type == "Thêm") {
      addStore();
    } else {
      updateStore();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              <InputFields data={fields}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Xác nhận
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
});
export default ModalAction;
